
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/things-to-do/[slug]",
      function () {
        return require("private-next-pages/things-to-do/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/things-to-do/[slug]"])
      });
    }
  